
import React from 'react';
import { Lead, LeadPriority, LeadStatus, leadPriorityLabels, leadStatusLabels } from '@/components/leads/types';
// DetailItem removed as it's no longer used for these fields
import { EditableDetailItem } from '../EditableDetailItem';
import { Tag, BarChart3, Info, CalendarClock, History } from 'lucide-react';

interface BusinessDevelopmentSectionProps {
  lead: Lead;
  handleFieldSave: (leadId: string, fieldName: keyof Lead, value: any) => Promise<void>;
  isUpdatingLead: boolean;
  formatBadgeDisplay: (value: any, fieldName: keyof Lead, selectOptions?: Record<string, string>) => React.ReactNode;
}

export const BusinessDevelopmentSection: React.FC<BusinessDevelopmentSectionProps> = ({ lead, handleFieldSave, isUpdatingLead, formatBadgeDisplay }) => {
  return (
    <div className="py-4">
      <h3 className="text-md font-semibold mb-3 text-gray-800 flex items-center"><BarChart3 size={18} className="mr-2 text-primary"/>Business Development</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-1">
        <EditableDetailItem
          icon={<Tag size={16} />} 
          label="Priority" 
          value={lead.priority}
          fieldName="priority"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="select"
          selectOptions={leadPriorityLabels}
          displayFormatter={formatBadgeDisplay}
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem
          icon={<BarChart3 size={16} />} 
          label="Status" 
          value={lead.status}
          fieldName="status"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="select"
          selectOptions={leadStatusLabels}
          displayFormatter={formatBadgeDisplay}
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem 
            icon={<Info size={16} />} 
            label="Lead Source" 
            value={lead.source} 
            fieldName="source"
            leadId={lead.id}
            onSave={handleFieldSave}
            inputType="text"
            isLoading={isUpdatingLead}
        />
        <EditableDetailItem
          icon={<CalendarClock size={16} />}
          label="Next Contact Date"
          value={lead.next_contact_at}
          fieldName="next_contact_at"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="date"
          isLoading={isUpdatingLead}
        />
        <EditableDetailItem
          icon={<History size={16} />}
          label="Last Contact Date"
          value={lead.last_contact}
          fieldName="last_contact"
          leadId={lead.id}
          onSave={handleFieldSave}
          inputType="date"
          isLoading={isUpdatingLead}
        />
      </div>
    </div>
  );
};
